import { render, staticRenderFns } from "./TitleIconComponent.vue?vue&type=template&id=1b6e9d1f"
import script from "./TitleIconComponent.vue?vue&type=script&lang=js"
export * from "./TitleIconComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports